import { render, staticRenderFns } from "./mobileHistoryLayout.vue?vue&type=template&id=29e96f59&scoped=true&"
import script from "./mobileHistoryLayout.vue?vue&type=script&lang=js&"
export * from "./mobileHistoryLayout.vue?vue&type=script&lang=js&"
import style0 from "./mobileHistoryLayout.vue?vue&type=style&index=0&id=29e96f59&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e96f59",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VAlert,VBtn,VCol,VRow,VSnackbar})
